let url = 'https://feeds.behold.so/kux1v8LKpNL0oRMH75Xc';

fetch(url)
  .then(res => res.json())
  .then(data => {
    if (window.manualFeedItems && window.manualFeedItems.length > 0) {
      data = data.concat(window.manualFeedItems);
    }
    createFeed(data);
  })
  .catch(err => { throw err });

function createFeed(data) {

  console.log(data);
  var parent, container, item;

  parent = document.querySelector("#social-ticker");
  container = parent.getElementsByTagName("template")[0];
  item = container.content.querySelector("img");
  var targets = parent.querySelectorAll('.ticker')



  // Split data into two halves
  var half = Math.ceil(data.length / 2);
  var part1 = data.slice(0, half);
  var part2 = data.slice(half);

  // Randomly swap 3 items between the two halves if enough items exist
  if (part1.length >= 3 && part2.length >= 3) {
    for (let i = 0; i < 3; i++) {
      let idx1 = Math.floor(Math.random() * part1.length);
      let idx2 = Math.floor(Math.random() * part2.length);

      // Swap
      let temp = part1[idx1];
      part1[idx1] = part2[idx2];
      part2[idx2] = temp;
    }
  }

  part1 = distributeVideos(part1);
  part2 = distributeVideos(part2);
  var batches = [part1, part2];

  targets.forEach(function (target, index) {
    var ul = target.querySelector('.ticker__list');
    var currentRow = index;
    ul.innerHTML = '';

    var batch = batches[index];
    if (!batch) return;

    batch.forEach(post => {
      var element = createElement(post, item, currentRow);
      insertInDom(ul, element);
    });
  });
  initTicker();

}

function distributeVideos(arr) {
  var videos = arr.filter(i => i.mediaType === 'VIDEO');
  shuffle(videos);
  var others = arr.filter(i => i.mediaType !== 'VIDEO');
  shuffle(others);
  var result = [];

  while (videos.length > 0 || others.length > 0) {
    var lastIsVideo = result.length > 0 && result[result.length - 1].mediaType === 'VIDEO';
    if (lastIsVideo) {
      if (others.length > 0) result.push(others.shift());
      else result.push(videos.shift());
    } else {
      if (videos.length > 0) result.push(videos.shift());
      else result.push(others.shift());
    }
  }
  return result;
}

function createElement(data, item, currentRow) {
  var mediaEl;
  var li = document.createElement('li');

  if (data.mediaType == 'VIDEO') {
    mediaEl = document.createElement('video');
    mediaEl.setAttribute('muted', 'true');
    mediaEl.setAttribute('autoplay', 'true');
    mediaEl.setAttribute('loop', 'true');
    mediaEl.setAttribute('playsinline', 'true');
    mediaEl.className = item.className;

    var source = document.createElement('source');
    source.src = data.mediaUrl;
    source.type = "video/mp4";
    mediaEl.appendChild(source);
  } else if (data.mediaType == 'CAROUSEL_ALBUM' && data.children) {
    mediaEl = document.createElement('div');
    mediaEl.className = 'carousel-wrapper ' + item.className;

    data.children.forEach((child, index) => {
      // Only process IMAGE children for now to keep it simple, or video if needed but usually carousels are mixed.
      // We'll treat them as images for simplicity based on request 'flick between them'
      if (child.mediaType === 'IMAGE') {
        var img = document.createElement('img');
        img.src = child.mediaUrl;
        if (index === 0) img.classList.add('is-visible');
        mediaEl.appendChild(img);
      }
    });
  } else {
    mediaEl = document.importNode(item, true);
    mediaEl.src = data.mediaUrl;
  }

  // Set aspect ratio if dimensions exist
  if (data.dimensions && data.dimensions.width && data.dimensions.height) {
    mediaEl.style.aspectRatio = data.dimensions.width + ' / ' + data.dimensions.height;
  }

  if (currentRow > 0) {
    li.className = 'ticker__item padding-x-md padding-top-' + randomClassAssignerY();
  } else {
    li.className = 'ticker__item padding-x-md padding-bottom-' + randomClassAssignerY();
  }

  if (data.isReel) {
    li.classList.add('ticker__item--is-reel');
  }

  li.appendChild(mediaEl);
  return li;
}

function initCarouselFlicker() {
  setInterval(() => {
    var carousels = document.querySelectorAll('.carousel-wrapper');
    carousels.forEach(wrapper => {
      var images = wrapper.querySelectorAll('img');
      if (images.length < 2) return;

      var current = wrapper.querySelector('.is-visible');
      var next;

      if (current && current.nextElementSibling) {
        next = current.nextElementSibling;
      } else {
        next = images[0];
      }

      if (current) current.classList.remove('is-visible');
      next.classList.add('is-visible');
    });
  }, 2500); // Flick every 2.5 seconds
}

function insertInDom(target, item) {
  target.appendChild(item);
}

function randomClassAssignerY() {
  var classesArray = ['sm', 'md', 'lg', 'sm', 'md', 'lg', 'sm', 'md', 'lg', 'sm', 'md', 'lg'];
  const randomIndex = Math.floor(Math.random() * classesArray.length);
  const randomClass = classesArray[randomIndex];
  return randomClass;
}

function randomClassAssignerX() {
  var classesArray = ['md', 'lg', 'md', 'lg', 'sm', 'md', 'lg', 'md', 'lg'];
  const randomIndex = Math.floor(Math.random() * classesArray.length);
  const randomClass = classesArray[randomIndex];
  return randomClass;
}

function shuffle(array) {
  let currentIndex = array.length, randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}


function initTicker() {
  // File#: _1_ticker
  // Usage: codyhouse.co/license
  var Ticker = function (element) {
    this.element = element;
    this.list = this.element.getElementsByTagName('ul')[0];
    this.items = this.list.children;
    this.paused = false;
    // clones info
    this.clones = this.list.innerHTML;
    this.clonesNumber = 1;
    this.itemsLength = this.items.length;
    // animation duration
    //   this.animationDuration = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ticker-animation-duration'));
    this.animationDuration = parseInt(this.element.dataset.duration);
    initTicker(this);
  };

  function initTicker(ticker) {
    // clone ticker children
    setTickerWidth(ticker);
    cloneItems(ticker);
    initAnimation(ticker);

    // Start carousel flicker globally once ticker is initialized
    if (!window.carouselTickerStarted) {
      initCarouselFlicker();
      window.carouselTickerStarted = true;
    }

    // resize/font loaded event
    ticker.element.addEventListener('update-ticker', function (event) {
      setTickerWidth(ticker);
      cloneItems(ticker);
    });

    // click on control button events
    ticker.element.addEventListener('anim-ticker', function (event) {
      ticker.paused = false;
      Util.removeClass(ticker.element, 'ticker--paused');
    });

    ticker.element.addEventListener('pause-ticker', function (event) {
      ticker.paused = true;
      Util.addClass(ticker.element, 'ticker--paused');
    });

    // all set
    Util.addClass(ticker.element, 'ticker--loaded');
  };

  function setTickerWidth(ticker) {
    var width = 0;
    for (var i = 0; i < ticker.itemsLength; i++) {
      width = width + getItemWidth(ticker.items[i]);
    }
    // check if we need to update the number of clones
    if (width > 0 && width < window.innerWidth) {
      ticker.clonesNumber = Math.min(Math.ceil(window.innerWidth / width) * 2 - 1, 10);
    } else {
      ticker.clonesNumber = 1;
    }

    // update list width
    ticker.list.style.width = ((ticker.clonesNumber + 1) * width) + 'px';
  };

  function getItemWidth(item) {
    var style = window.getComputedStyle(item);
    return parseFloat(style.marginRight) + parseFloat(style.marginLeft) + item.offsetWidth;
  };

  function cloneItems(ticker) {
    ticker.list.innerHTML = ticker.clones;
    for (var i = 0; i < ticker.clonesNumber; i++) {
      ticker.list.insertAdjacentHTML('beforeend', ticker.clones);
    }
    // update animation duration
    ticker.element.style.setProperty('--ticker-animation-duration', ticker.animationDuration * (ticker.clonesNumber + 1) + 's');
  };

  function initAnimation(ticker) {
    // init observer - animate ticker only when in viewport
    var observer = new IntersectionObserver(tickerObserve.bind(ticker));
    observer.observe(ticker.element);

  };

  function tickerObserve(entries) {
    if (entries[0].isIntersecting) {
      if (!this.paused) Util.addClass(this.element, 'ticker--animate');
    } else {
      Util.removeClass(this.element, 'ticker--animate');
    }
  };

  function initTickerController(controller) {
    // play/pause btn controller
    var tickerContainer = document.getElementById(controller.getAttribute('aria-controls'));
    if (!tickerContainer) return;
    var tickerList = tickerContainer.getElementsByClassName('js-ticker');
    if (tickerList.length < 1) tickerList = [tickerContainer];
    // detect click
    controller.addEventListener('click', function (event) {
      var playAnimation = controller.getAttribute('aria-pressed') == 'true';
      var animEvent = playAnimation ? 'anim-ticker' : 'pause-ticker';
      playAnimation ? controller.setAttribute('aria-pressed', 'false') : controller.setAttribute('aria-pressed', 'true');
      for (var i = 0; i < tickerList.length; i++) {
        tickerList[i].dispatchEvent(new CustomEvent(animEvent));
      }
    });
  };

  //initialize the Ticker objects
  var tickers = document.getElementsByClassName('js-ticker'),
    requestAnimationFrameSupported = window.requestAnimationFrame,
    reducedMotion = Util.osHasReducedMotion(),
    intersectionObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);

  if (tickers.length > 0) {
    var tickersArray = [];
    for (var i = 0; i < tickers.length; i++) {
      if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
        // animation is off if requestAnimationFrame/IntersectionObserver is not supported or reduced motion is on
        Util.addClass(tickers[i], 'ticker--anim-off');
      } else { (function (i) { tickersArray.push(new Ticker(tickers[i])); })(i); }
    }

    if (tickersArray.length > 0) {
      var resizingId = false,
        customEvent = new CustomEvent('update-ticker');

      // on resize -> update ticker width 
      window.addEventListener('resize', function () {
        clearTimeout(resizingId);
        resizingId = setTimeout(doneResizing, 500);
      });

      // wait for font to be loaded -> update ticker width
      if (document.fonts) {
        document.fonts.onloadingdone = function (fontFaceSetEvent) {
          doneResizing();
        };
      }

      function doneResizing() {
        for (var i = 0; i < tickersArray.length; i++) {
          (function (i) { tickersArray[i].element.dispatchEvent(customEvent) })(i);
        };
      };

      // ticker play/pause buttons
      var tickerControl = document.getElementsByClassName('js-ticker-control');
      if (tickerControl.length > 0) {
        for (var i = 0; i < tickerControl.length; i++) {
          if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
            Util.addClass(tickerControl[i], 'is-hidden');
          } else {
            (function (i) { initTickerController(tickerControl[i]); })(i);
          }
        }
      }
    };
  }



}